export default __webpack_public_path__ + "static/media/giphy (1).3c6f7c8c.gif";